module.exports = __webpack_public_path__ + "img/img33.bf5d8773.svg";